import Module from '@/store/resource/common/module';
import Notes from '@/store/resource/notes';

let module = new Module(new Notes());

export default module.create();
